<template>
  <v-container>
    <v-container>
      <div v-html="text"></div>
      <v-row>
        <v-spacer></v-spacer>
        Author: {{ author }}
      </v-row>
      <hr />
      <v-row>
        <v-spacer></v-spacer>
        <div>
          <span v-if="options.length > 1">What happens next?</span>
          <ul id="example-1">
              <li v-for="item in options" :key="item.pageID">
                  <a href="#" @click.prevent="loadPage(item)" :class="getRefClass(item.written)">{{ item.text }}</a>
              </li>
          </ul>
        </div>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
// import config from '../config.js'

export default {
  name: 'PageView',
  props: ['title', 'text', 'options', 'author'],
  data: () => ({
    loading: true

  }),
  mounted () {

  },
  methods: {
    getRefClass (written) {
      if (!written) {
        return 'red--text'
      } else {
        return ''
      }
    },
    loadPage (opt) {
      const newPageID = opt.pageID
      // console.log('Load page: ' + JSON.stringify(opt))
      // Load the next page
      this.$router.push({
        path: '/read/' + this.$route.params.storyID + '/' + newPageID,
        query: { optID: opt.id, optTxt: opt.text } // Send the option we're coming from
      }).then(() => {
        this.$emit('reloadPage')
      })
      return false
    }
  }

}
</script>
